import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  mounted () {
    this.options = {
      legend: {
        display: false
      },
      tooltips: {
          // Disable the on-canvas tooltip
        enabled: false,

        custom: function (tooltipModel) {
              // Tooltip Element
          var tooltipEl = document.getElementById('chartjs-tooltip')

              // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div')
            tooltipEl.id = 'chartjs-tooltip'
            tooltipEl.innerHTML = '<table></table>'
            document.body.appendChild(tooltipEl)
          }

              // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0
            return
          }

              // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform')
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign)
          } else {
            tooltipEl.classList.add('no-transform')
          }

          function getBody (bodyItem) {
            return bodyItem.lines
          }

              // Set Text
          if (tooltipModel.body) {
            var titleLines = tooltipModel.title || []
            var bodyLines = tooltipModel.body.map(getBody)

            var innerHtml = '<thead>'

            titleLines.forEach(function (title) {
              innerHtml += '<tr><th>' + title + '</th></tr>'
            })
            innerHtml += '</thead><tbody>'

            bodyLines.forEach(function (body, i) {
              var colors = tooltipModel.labelColors[i]
              var style = 'background:' + colors.backgroundColor
              style += '; border-color:' + colors.borderColor
              style += '; border-width: 2px'
              var span = '<span style="' + style + '"></span>'
              innerHtml += '<tr><td>' + span + body + '%' + '</td></tr>'
            })
            innerHtml += '</tbody>'

            var tableRoot = tooltipEl.querySelector('table')
            tableRoot.innerHTML = innerHtml
          }

              // `this` will be the overall tooltip
          var position = this._chart.canvas.getBoundingClientRect()

              // Display, position, and set styles for font
          tooltipEl.style.opacity = 1
          tooltipEl.style.borderRadius = '5px'
          tooltipEl.style.height = '60px'
          tooltipEl.style.width = '98px'
          tooltipEl.style.boxShadow = '0px 0px 10px'
          tooltipEl.style.backgroundColor = 'white'
          tooltipEl.style.position = 'absolute'
          tooltipEl.style.padding = '10px'
          tooltipEl.style.fontWeight = 'bold'
          tooltipEl.style.margin = '0 0 10px'
          tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px'
          tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
          tooltipEl.style.pointerEvents = 'none'
        }
      },
      maintainAspectRatio: false
    }

    this.addPlugin({
      afterDraw (chart) {
        var width = chart.chart.width
        var height = chart.chart.height
        var ctx = chart.chart.ctx

        ctx.restore()
        var fontSize = (height / 120).toFixed(2)
        ctx.font = fontSize + 'em sans-serif'
        ctx.fillStyle = chart.data.centerTextColor
        ctx.textBaseline = 'middle'

        var text = chart.data.centerTextValue
        var textX = Math.round((width - ctx.measureText(text).width) / 2)
        var textY = height / 2

        ctx.fillText(text, textX, textY)
        ctx.save()

        if (chart.data.postRender) {
          chart.data.postRender(chart)
        }
      }
    })

    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    update: function (centerTextValue, centerTextColor) {
      this.chartData.centerTextValue = centerTextValue
      this.chartData.centerTextColor = centerTextColor
      this.renderChart(this.chartData, this.options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/charts/DoughnutChart.js